<template>
  <base-dialog @cancel="cancelDialog">
    <div slot="header">实名认证</div>
    <div slot="body">
      <a-form :form="form.fc">
        <a-form-item label="姓名" v-bind="formItemLayout">
          <a-input v-decorator="decorator.name" placeholder="请填写姓名" />
        </a-form-item>
        <a-form-item label="身份证号" v-bind="formItemLayout">
          <a-input v-decorator="decorator.id_number" placeholder="请填写身份证号" />
        </a-form-item>
      </a-form>
    </div>
    <div slot="footer">
      <a-button type="primary" @click="handleConfirm" :loading="loading">实名认证</a-button>
      <a-button @click="cancelDialog">{{ $t('dialog.cancel') }}</a-button>
    </div>
  </base-dialog>
</template>

<script>
import DialogMixin from '@/mixins/dialog'
import WindowsMixin from '@/mixins/windows'

export default {
  name: 'UserVerifyQrcodeDialog',
  mixins: [DialogMixin, WindowsMixin],
  data () {
    return {
      loading: false,
      form: {
        fc: this.$form.createForm(this),
      },
      decorator: {
        name: [
          'name',
          {
            rules: [
              { required: true, message: '请填写姓名' },
            ],
          },
        ],
        id_number: [
          'id_number',
          {
            validateFirst: true,
            rules: [
              { required: true, message: '请填写身份证号' },
              { validator: this.$validate('idCard') },
            ],
          },
        ],
      },
      formItemLayout: {
        wrapperCol: {
          span: 18,
        },
        labelCol: {
          span: 5,
        },
      },
    }
  },
  methods: {
    doCertify (data) {
      return new this.$Manager('customers').performAction({
        id: this.params.customerId,
        action: 'certify-creator',
        data,
      })
    },
    async handleConfirm () {
      this.loading = true
      try {
        const { name, id_number } = await this.form.fc.validateFields()
        await this.doCertify({ name, id_number })
        this.loading = false
        this.cancelDialog()
        this.$message.success('实名认证成功')
        this.$store.dispatch('app/getCustomerCapabilities')
      } catch (error) {
        this.loading = false
      }
    },
  },
}
</script>
